(function () {
  'use strict';

    // The collection page is a stack of independent sections now, each with its
  // own [data-cr-root]. Querying from the document reaches all of them; a
  // single root animated only the first band on the page.
  if (window.__czardCollectionInit) return;
  if (!document.querySelector('[data-cr-root]')) return;
  window.__czardCollectionInit = true;
  var root = document;


  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var STEP = 90;
  var LINE_STEP = 90;
  var ROOM = 0.14;

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  if (reduce) {
    var all = root.querySelectorAll('[data-cr]');
    for (var r = 0; r < all.length; r++) all[r].classList.add('is-cr-in');
    initCrown();
    return;
  }

  function splitLines(el) {
    var html = el.innerHTML;
    if (!html) return false;

    var parts = html.split(/<br\s*\/?>/i);
    var out = '';

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (!part) continue;
      out +=
        '<span class="cr-line"><span class="cr-line__in" style="--cr-line-d:' +
        i * LINE_STEP +
        'ms">' +
        part +
        '</span></span>';
    }

    if (!out) return false;
    el.innerHTML = out;
    el.classList.add('is-cr-split');
    return true;
  }

  var lineEls = root.querySelectorAll('[data-cr="lines"]');
  for (var l = 0; l < lineEls.length; l++) {
    try {
      splitLines(lineEls[l]);
    } catch (e) {
    }
  }

  var revealEls = Array.prototype.slice.call(root.querySelectorAll('[data-cr]'));

  revealEls.forEach(function (el) {
    var d = parseInt(el.getAttribute('data-cr-delay'), 10);
    if (!isNaN(d) && d > 0) el.style.setProperty('--cr-d', d * STEP + 'ms');
  });

  if ('IntersectionObserver' in window) {
    var watched = new Map();

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;

          var targets = watched.get(entries[i].target);
          if (targets) {
            for (var t = 0; t < targets.length; t++) targets[t].classList.add('is-cr-in');
          }

          io.unobserve(entries[i].target);
          watched.delete(entries[i].target);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    revealEls.forEach(function (el) {
      var proxy = el.getAttribute('data-cr') === 'clip' ? el.parentElement || el : el;

      var list = watched.get(proxy);
      if (list) list.push(el);
      else watched.set(proxy, [el]);
    });

    watched.forEach(function (_targets, proxy) {
      io.observe(proxy);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-cr-in');
    });
  }

  var parallaxEls = Array.prototype.slice.call(root.querySelectorAll('[data-cr-parallax]'));
  var LERP = 0.085;
  var EPS = 0.05;

  var items = parallaxEls
    .map(function (frame) {
      var media = frame.firstElementChild;
      if (!media) return null;

      var speed = parseFloat(frame.getAttribute('data-cr-parallax'));
      if (isNaN(speed)) speed = 8;

      return { frame: frame, media: media, speed: speed / 100, target: 0, current: 0, painted: null };
    })
    .filter(Boolean);

  function measure(vh) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var rect = it.frame.getBoundingClientRect();

      if (rect.bottom < -160 || rect.top > vh + 160) {
        it.target = 0;
        continue;
      }

      var center = rect.top + rect.height / 2;
      var p = (center - vh / 2) / (vh / 2 + rect.height / 2);
      it.target = clamp(-p * it.speed, -ROOM, ROOM) * rect.height;
    }
  }

  var LS = window.LuxeScroll;

  if (items.length && LS) {
    LS.register({
      measure: function (s) {
        measure(s.vh);
      },

      paint: function () {
        var moving = false;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          var delta = it.target - it.current;

          if (Math.abs(delta) < EPS) {
            it.current = it.target;
          } else {
            it.current += delta * LERP;
            moving = true;
          }

          var next = it.current.toFixed(2);
          if (next === it.painted) continue;
          it.painted = next;
          it.media.style.transform = 'translate3d(0,' + next + 'px,0)';
        }

        return moving;
      }
    });

    measure(window.innerHeight || document.documentElement.clientHeight);
    for (var p = 0; p < items.length; p++) {
      items[p].current = items[p].target;
      items[p].painted = items[p].current.toFixed(2);
      items[p].media.style.transform = 'translate3d(0,' + items[p].painted + 'px,0)';
    }
  }

  function initCrown() {
    var section = root.querySelector('[data-cr-crown]');
    if (!section) return;

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cr-crown-item]'));
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-cr-crown-tab]'));
    if (!items.length) return;

    var index = 0;

    function show(next) {
      index = (next + items.length) % items.length;

      for (var t = 0; t < tabs.length; t++) {
        var on = t === index;
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        show(i);
      });
    });

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        show(index - 1);
      } else if (e.key === 'ArrowRight') {
        show(index + 1);
      } else {
        return;
      }
      if (tabs[index]) tabs[index].focus();
    });

    show(0);
  }

  initCrown();
})();
